// extracted by mini-css-extract-plugin
module.exports = {"title":"a075c","buttons":"_52366"};